module.exports = __webpack_public_path__ + "img/google_logo.437bed9a.png";